import { useState, useEffect } from "react";
import { gql } from "@apollo/client";

// Constants
import { genSetVars } from "@/constants/gql-fields";

// Style
import style from "@/styles/single-ingredient.module.scss";

// Components
import Head from "next/head";
import Header from "@/components-layout/header/header";
import Footer from "@/components-layout/footer/footer";
import Container from "@/components-layout/container/container";
import Modal from "@/components/modal/modal";
import AbaIcon from "@/components/aba-icon/aba-icon";
import RegAgency from "@/components/single-ingrd/reg-agency/reg-agency";
import InfoCard from "@/components/single-ingrd/info-card/info-card";
import ScrollBtn from "@/components/scroll-btn/scroll-btn";

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return <>Loading...</>;
  }

  // UseState
  const [showModal, setShowModal] = useState(false);
  const [popupData, setPopupData] = useState({});

  // Variables
  const data = props.data;
  // const siteTitle = data.generalSettings.title;
  const ingrd = data.ingredient;
  const title = ingrd.title;
  const date = ingrd.modified ? new Date(ingrd.modified) : null;
  const ingrdFields = ingrd.ingredientsFields;
  const fdaAuth = ingrdFields.fdaAuthorizations;
  const regAgencies = ingrdFields.regulatoryAgencies;
  let allTerms = [];

  if (data?.commonTerms?.nodes) {
    allTerms = [...data?.commonTerms?.nodes];
  }
  if (fdaAuth?.authorizations?.nodes) {
    allTerms = [...allTerms, ...fdaAuth?.authorizations?.nodes];
  }

  useEffect(() => {
    // Popup button click handler
    const btns = document.getElementsByClassName("termBtn");
    if (btns) {
      Array.from(btns).map((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const btn = e.currentTarget;
          btn.ariaExpanded = true;

          setShowModal(true);

          const info = allTerms.find(
            (option) => option.title.toLowerCase() === btn.dataset.term
          );
          info.btn = btn;

          setPopupData(info);
        });
      });
    }

    // Lock scroll
    if (showModal && window.innerWidth <= 750) {
      document.body.style.overflow = "hidden";
    } else if (document.body.style.overflow == "hidden") {
      document.body.style.overflow = "unset";
    }
  }, [showModal]);

  return (
    <>
      <Head>
        <title>{ingrd.seo.title}</title>
        <meta name="description" content={ingrd.seo.metaDesc} />
        {/* <title>{`${title} - ${siteTitle}`}</title> */}
      </Head>

      <Header entry={data.generalSettingsOptionsPage.generalSettingsACF} />

      <main className="singleIngredient" style={{ position: "relative" }}>
        <section className={style.ingrdSec}>
          <Container>
            <div className={style.ingrdWrapper}>
              <div className={style.headingContainer}>
                <div className={style.contentContainer}>
                  <AbaIcon name={AbaIcon.LIST.list} color="#fff" />
                  <div
                    className={style.headingContent}
                    dangerouslySetInnerHTML={{ __html: ingrdFields.about }}
                  />
                </div>
                <div className={style.titleContainer}>
                  <h1 className={style.title}>{title}</h1>
                </div>
              </div>

              {/* {ingrdFields.moreInfo && (
                <div className={style.moreInfo}>
                  <h2>More Information:</h2>
                  <div
                    dangerouslySetInnerHTML={{ __html: ingrdFields.moreInfo }}
                  />
                </div>
              )} */}

              <div className={style.contentContainer}>
                {ingrdFields.foundIn && (
                  <InfoCard
                    label={"Found In"}
                    data={ingrdFields.foundIn}
                    // icon={"checkmark"}
                    color={"#0067a0"}
                  />
                )}
                {ingrdFields.aliases && (
                  <InfoCard
                    label={"Also Known As"}
                    data={ingrdFields.aliases}
                    // icon={"equal"}
                    color={"#1fb4ff"}
                  />
                )}
                {/* {ingrdFields.status && (
                  <InfoCard
                    label={"US Authorizations"}
                    data={ingrdFields.status}
                    icon={"star"}
                    color={"#00c6dc"}
                    addInfo
                  />
                )} */}
                {ingrdFields.theBottomLine && (
                  <InfoCard
                    label={"The Beverage Bottom Line"}
                    data={ingrdFields.theBottomLine}
                    // icon={"star"}
                    color={"#00c6dc"}
                  />
                )}
              </div>
            </div>
          </Container>
        </section>

        {regAgencies && (
          <section className={style.regSection}>
            <Container>
              <h2>International Assessments and Authorizations</h2>
              <div className="agenciesWrapper">
                <div className={style.agencyItems}>
                  {regAgencies.map((agency, i) => {
                    return (
                      <RegAgency regItem={agency} auth={fdaAuth} key={i} />
                    );
                  })}
                </div>

                {/* {regAgencies["us"] && (
                  <div className={style.agencyItems + " " + style.usaItems}>
                    <div className={style.agencyLabel}>
                      <AbaIcon name={AbaIcon.LIST.usa} />
                      <h3>Authorization in The United States</h3>
                    </div>
                    {regAgencies["us"].map((agency, i) => {
                      return <RegItem {...agency} key={i} />;
                    })}
                  </div>
                )}
                {regAgencies["global"] && (
                  <div className={style.agencyItems + " " + style.globalItems}>
                    <div className={style.agencyLabel}>
                      <AbaIcon name={AbaIcon.LIST.wireGlobe} />
                      <h3>Global Authorization</h3>
                    </div>
                    {regAgencies["global"].map((agency, i) => {
                      return <RegItem {...agency} key={i} />;
                    })}
                  </div>
                )} */}
              </div>
            </Container>
          </section>
        )}

        {date && (
          <section className={style.disclaimer}>
            <Container>
              <div>
                <p>
                  This page was last updated on {date.toLocaleDateString()}.
                </p>
              </div>
            </Container>
          </section>
        )}

        {showModal && popupData && (
          <Modal setShowModal={setShowModal} popupData={popupData} />
        )}

        <ScrollBtn />
      </main>

      <Footer entry={data.generalSettingsOptionsPage.generalSettingsACF} />
    </>
  );
}

Component.variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview,
    termIDs: [
      2556, // Codex Alimentarius
      2555, // European Commission
      2287, // Health Canada
      2136, // JECFA
      2135, // FAO
      2134, // WHO
      2133, // EFSA
      2128, // FDA
    ],
  };
};

Component.query = gql`
  query GetPost($databaseId: ID!, $asPreview: Boolean = false, $termIDs: [ID]) {
    # -- Site Settings
    # generalSettings {
    #   title
    # }

    # -- Header Fragment
    ...HeaderFragment @unmask(mode: "migrate")

    # -- Footer
    ...FooterFragment @unmask(mode: "migrate")

    # -- Post Data
    ingredient(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      __typename
      id
      title
      uri
      modified
      ingredientsFields {
        __typename
        about
        # moreInfo
        aliases
        foundIn
        theBottomLine
        # status {
        #   nodes {
        #     ... on CommonTerm {
        #       id
        #       title
        #       ptTermsFields {
        #         __typename
        #         popupDescription
        #         popupLabel
        #       }
        #     }
        #   }
        # }

        fdaAuthorizations {
          label
          authorizations {
            nodes {
              ... on CommonTerm {
                id
                title
                ptTermsFields {
                  __typename
                  popupDescription
                  popupLabel
                }
              }
            }}
        }

        regulatoryAgencies {
          __typename
          id
          ...RegAgencyFragment
        }
      }
      seo {
        metaDesc
        # fullHead
        title
      }
    }

   commonTerms(first:100, where: { in: $termIDs, status: PUBLISH}) {
    nodes {
      id
      title
      ptTermsFields {
        __typename
        popupLabel
        popupDescription
      }
    }
  }

    # -- General Settings Variables
    ${genSetVars}
  }
  ${Header.fragments.entry}
  ${Footer.fragments.entry}
  ${RegAgency.fragments.entry}
`;
